'use client';

import { IcCalendar, IcMy, IcSearch } from '@yanolja-rnd/nol-icons';

interface GlobalSearchMobileProps {
  placeholder?: string;
  onClickSearch?: () => void;
  onClickCalendar?: () => void;
  onClickRooms?: () => void;
  checkInOutText?: string;
  roomAndGuestText?: string;
}

export const GlobalSearchMobile = ({
  placeholder,
  onClickSearch,
  onClickCalendar,
  onClickRooms,
  checkInOutText,
  roomAndGuestText,
}: GlobalSearchMobileProps) => {
  return (
    <div className="mx-16 my-12 flex flex-col rounded-12 border border-line-neutral-main shadow-2 pc:hidden">
      <div className="flex h-48 items-center border-b border-b-line-neutral-weak2">
        <button
          type="button"
          className="inline-flex w-full items-center px-12 py-12 text-start"
          onClick={onClickSearch}>
          <IcSearch width={20} height={20} className="min-h-20 min-w-20" />
          <span className="ml-4 line-clamp-1 cursor-text text-text-neutral-sub typography-body-14-regular">
            {placeholder}
          </span>
        </button>
      </div>
      <div className="flex h-48 w-full py-12">
        <div className="flex w-1/2 items-center border-r border-r-line-neutral-weak2">
          <button type="button" className="inline-flex w-full items-center px-12 text-start" onClick={onClickCalendar}>
            <IcCalendar width={20} height={20} className="min-h-20 min-w-20" />
            <span className="ml-4 line-clamp-1 text-text-neutral-main typography-body-14-bold">{checkInOutText}</span>
          </button>
        </div>
        <div className="flex w-1/2 items-center">
          <button
            type="button"
            className="inline-flex w-full items-center pl-10 pr-8 text-start"
            onClick={onClickRooms}>
            <IcMy width={20} height={20} className="min-h-20 min-w-20" />
            <span className="ml-4 line-clamp-1 text-text-neutral-main typography-body-14-bold">{roomAndGuestText}</span>
          </button>
        </div>
      </div>
    </div>
  );
};
